import React, { Component, Fragment } from 'react';
import Config from '../Config';
import i18n from './i18next/i18next';
import UserContext from '../components/context/UserContext';

import '../assets/css/home.css';

class Home extends Component {
  constructor(props) {
    super(props);

    const user = JSON.parse(localStorage.getItem('dlinkuser'));
    const isLogin = user && user.access_token ? true : false;

    if (isLogin) {
      this.props.history.push('/profile');
    }
  }

  signIn = lang => {
    window.location.href = `${Config.oauthUrl}?client_id=${
      Config.clientId
    }&redirect_uri=${
      Config.redirectUrl
    }&response_type=token&scope=basic&state=&hint=&lang=${lang || 'en'}`;
  };

  renderContent = language => {
    return (
      <Fragment>
        <div className="sign_in_banner">
          <div className="banner_wave" />
          <div className="banner_content">
            <div className="banner_title">
              {i18n.t('home.title', { lng: language })}
            </div>
            <div className="banner_slogan">
              {i18n.t('home.slogan', { lng: language })}
            </div>
            <div className="banner_btn" onClick={() => this.signIn(language)}>
              {i18n.t('signIn', { lng: language })}
            </div>
          </div>
        </div>
        <div className="account_feature">
          <div className="feature_item">
            <div className="feature_icon feature_icon_01" />
            <div className="feature_title">
              {i18n.t('home.manageAccount', { lng: language })}
            </div>
            <div className="feature_txt">
              {i18n.t('home.manageAccountDesc', { lng: language })}
            </div>
          </div>

          <div className="feature_item">
            <div className="feature_icon feature_icon_02" />
            <div className="feature_title">
              {i18n.t('home.archiveData', { lng: language })}
            </div>
            <div className="feature_txt">
              {i18n.t('home.archiveDataDesc', { lng: language })}
            </div>
          </div>

          <div className="feature_item">
            <div className="feature_icon feature_icon_03" />
            <div className="feature_title">
              {i18n.t('home.reviewProducts', { lng: language })}
            </div>
            <div className="feature_txt">
              {i18n.t('home.reviewProductsDesc', { lng: language })}
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <UserContext.Consumer>
        {({ language }) => this.renderContent(language)}
      </UserContext.Consumer>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js